module.exports = __webpack_public_path__ + "static/img/bg-es.2a94ec76.png";